export default __webpack_public_path__ + "static/media/9-qa-automatico.d47d497e.webp";